import { JsonObject, JsonProperty } from 'json2typescript';
import { ModelEntity, UtilsJsonConverterDate, UtilsMisc, UtilsString } from '@pit/core';
import { IDtoResourceType } from '../interfaces/dto.resource.type.interface';
import { IDtoResource, ResourceState } from '../interfaces/dto.resource.interface';
import { DtoResourceType } from './dto.resource.type';
import { IDtoUser } from '../interfaces/dto.user.interface';
import { DtoUser } from './dto.user';
import { IDtoDepot } from '../interfaces/dto.depot.interface';
import { DtoDepot } from './dto.depot';
import { IDtoMandator } from '../interfaces/dto.mandator.interface';
import { DtoMandator } from './dto.mandator';
import { IDtoResourceAttribute } from '../interfaces/dto.resource.attribute.interface';
import { DtoResourceAttribute } from './dto.resource.attribute';
import { IDtoResourceCheck } from '../interfaces/dto.resource.check.interface';
import { DtoResourceCheck } from './dto.resource.check';

// @dynamic
@JsonObject('DtoResource')
export class DtoResource extends ModelEntity implements IDtoResource {

    constructor(initValues: Partial<IDtoResource> = null) {
        super();

        if (initValues !== null) {
            Object.assign(this, initValues);
        }
    }

    @JsonProperty('code', String, true)
    public code?: string = null;

    @JsonProperty('description', String, true)
    public description?: string = null;

    @JsonProperty('deviceId', String, true)
    public deviceId?: string = null;

    @JsonProperty('resourceId', String, true)
    public resourceId?: string = null;

    @JsonProperty('state', Number, true)
    public state?: ResourceState = ResourceState.Active;

    @JsonProperty('capacity', Number, true)
    public capacity?: number = null;

    @JsonProperty('numberTour', String, true)
    public numberTour?: string = null;

    @JsonProperty('timestampLastUsed', UtilsJsonConverterDate, true)
    public timestampLastUsed?: Date = null;

    @JsonProperty('currentResourceCheck', DtoResourceCheck, true)
    public currentResourceCheck?: IDtoResourceCheck = null;

    @JsonProperty('depot', DtoDepot, true)
    public depot?: IDtoDepot = null;

    @JsonProperty('mandator', DtoMandator, true)
    public mandator?: IDtoMandator = null;

    @JsonProperty('type', DtoResourceType, true)
    public type?: IDtoResourceType = null;

    @JsonProperty('userCurrent', DtoUser, true)
    public userCurrent?: IDtoUser = null;

    @JsonProperty('userMain', DtoUser, true)
    public userMain?: IDtoUser = null;

    @JsonProperty('attributes', [DtoResourceAttribute], true)
    public attributes?: IDtoResourceAttribute[] = [];

    public getAttributeByKey(key: string): IDtoResourceAttribute {
        let result: IDtoResourceAttribute = null;

        if (this.getHasAttributes() === true) {
            result = this.attributes.find(x => (x.attributeKey.toLowerCase() === key.toLowerCase()));
        }

        return result;
    }

    public getHasAttributes(): boolean {
        return ((UtilsMisc.isNullOrUndefined(this.attributes) === false) && (this.attributes.length > 0));
    }

    public getHasCheckItems(): boolean {
        return ((UtilsMisc.isNullOrUndefined(this.currentResourceCheck) === false) && (this.currentResourceCheck.items.length > 0));
    }

    public getHasFaults(): boolean {
        return ((this.getHasCheckItems() === true) && (this.currentResourceCheck.getHasFaults() === true));
    }

    public getIsAssignableToUser(): boolean {
        return ((this.state === ResourceState.Active) && (UtilsMisc.isNullOrUndefined(this.userCurrent) === true));
    }

}
